(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-404-search]');
    if (!form) return;

    const input = form.querySelector('[data-404-input]');
    const hint = form.querySelector('[data-404-hint]');
    if (!input) return;

    const skip = ['products', 'collections', 'pages', 'blogs', 'search', '404'];
    const segment = window.location.pathname.split('/').filter(Boolean).pop();
    if (!segment || skip.includes(segment.toLowerCase())) return;

    let guess = '';
    try {
      guess = decodeURIComponent(segment);
    } catch {
      guess = segment;
    }
    guess = guess.replace(/\.[a-z0-9]{2,5}$/i, '').replace(/[-_+]+/g, ' ').trim().slice(0, 60);
    if (!guess) return;

    input.value = guess;
    if (hint) hint.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["academy-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COURSES_API = 'https://academy.mymechanic.no/api/courses/public';
    var SIGNUP_URL = 'https://academy.mymechanic.no/';
    var INITIAL_SHOW = 6;

    var CATEGORY_MAP = {
      diagnosekurs: { code: 'DIAG', label: 'Diagnosekurs' },
      programmeringskurs: { code: 'PROG', label: 'Programmeringskurs' },
      sikkerhetskurs: { code: 'SIKK', label: 'Sikkerhetskurs' },
      malekurs: { code: 'MÅLE', label: 'Målekurs' },
      batterikurs: { code: 'BATT', label: 'Batterikurs' }
    };

    function getCat(slug) {
      return CATEGORY_MAP[slug] || { code: 'KURS', label: '' };
    }

    function formatDate(startStr, endStr) {
      var opts = { day: 'numeric', month: 'short', year: 'numeric' };
      var start = new Date(startStr);
      var end = new Date(endStr);
      var s = start.toLocaleDateString('nb-NO', opts);
      if (start.toDateString() === end.toDateString()) return s;
      return start.toLocaleDateString('nb-NO', { day: 'numeric' }) + '.–' +
        end.toLocaleDateString('nb-NO', opts);
    }

    function formatPrice(price) {
      if (!price) return '';
      return 'kr ' + price.toLocaleString('nb-NO');
    }

    function renderCard(c, overflow) {
      var cat = getCat(c.categorySlug);
      var isFull = c.placesTotal > 0 && (c.placesTotal - c.placesTaken) <= 0;
      var placesLeft = c.placesTotal - c.placesTaken;
      var cls = 'course-card course-card--' + cat.code.toLowerCase();
      if (isFull) cls += ' is-full';
      var courseUrl = SIGNUP_URL + 'courses/' + c.id;

      var html = '<li class="' + cls + '"' + (overflow ? ' data-overflow' : '') + '>';
      html += '<div class="course-card__head">';
      html += '<span class="course-card__pill"><strong>' + cat.code + '</strong>';
      if (cat.label) html += ' · ' + cat.label;
      html += '</span>';
      if (isFull) {
        html += '<span class="course-card__badge course-card__badge--full">Fullt</span>';
      } else if (c.placesTotal > 0 && placesLeft <= 3) {
        html += '<span class="course-card__badge course-card__badge--low">' + placesLeft + ' plasser igjen</span>';
      }
      html += '</div>';
      html += '<h3 class="course-card__title">' + c.title + '</h3>';
      if (c.description) html += '<p class="course-card__desc">' + c.description + '</p>';
      html += '<div class="course-card__meta">';
      html += '<p class="course-card__date">';
      html += iconCalendar + ' ';
      html += formatDate(c.startDate, c.endDate);
      html += '</p>';
      if (c.location) html += '<p class="course-card__location">' + c.location + '</p>';
      if (c.price) html += '<p class="course-card__price">' + formatPrice(c.price) + '</p>';
      html += '</div>';
      if (c.placesTotal > 0 && !isFull) {
        html += '<p class="course-card__places">' + placesLeft + ' av ' + c.placesTotal + ' plasser ledig</p>';
      }
      var ctaLabel = isFull ? 'Bli kontaktet' : 'Meld deg på';
      html += '<a class="course-card__cta" href="' + courseUrl + '" target="_blank" rel="noopener noreferrer">';
      html += ctaLabel + ' ' + iconArrow;
      html += '</a></li>';
      return html;
    }

    var container = document.querySelector('[data-courses-container]');
    if (!container) return;
    var iconCalendar = container.dataset.iconCalendar || '';
    var iconArrow = container.dataset.iconArrow || '';

    fetch(COURSES_API)
      .then(function (r) { return r.json(); })
      .then(function (courses) {
        if (!courses.length) {
          container.innerHTML =
            '<div class="academy-courses__empty">' +
            '<p>Ingen kommende kurs er publisert akkurat nå. Bla i kursportalen eller meld deg på nyhetsbrevet for varsel.</p>' +
            '<a class="btn-primary" href="' + SIGNUP_URL + '" target="_blank" rel="noopener noreferrer">Se kursportalen</a>' +
            '</div>';
          return;
        }

        var needsMore = courses.length > INITIAL_SHOW;
        var gridHtml = '<ul class="academy-courses__grid" role="list" data-courses-grid>';
        courses.forEach(function (c, i) {
          gridHtml += renderCard(c, needsMore && i >= INITIAL_SHOW);
        });
        gridHtml += '</ul>';

        if (needsMore) {
          var hiddenCount = courses.length - INITIAL_SHOW;
          gridHtml += '<div class="academy-courses__more">' +
            '<button type="button" class="academy-courses__more-btn" data-courses-toggle ' +
            'data-more-label="Vis ' + hiddenCount + ' flere kurs" ' +
            'data-less-label="Vis færre kurs">' +
            '<span data-toggle-text>Vis ' + hiddenCount + ' flere kurs</span>' +
            '</button></div>';
        }

        container.innerHTML = gridHtml;

        container.querySelectorAll('[data-courses-toggle]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var grid = container.querySelector('[data-courses-grid]');
            if (!grid) return;
            var expanded = grid.dataset.expanded === 'true';
            var label = btn.querySelector('[data-toggle-text]');
            if (expanded) {
              delete grid.dataset.expanded;
              if (label) label.textContent = btn.dataset.moreLabel;
            } else {
              grid.dataset.expanded = 'true';
              if (label) label.textContent = btn.dataset.lessLabel;
            }
          });
        });
      })
      .catch(function () {
        container.innerHTML =
          '<div class="academy-courses__empty">' +
          '<p>Kunne ikke laste kurs. <a href="' + SIGNUP_URL + '" target="_blank">Se kursportalen</a> direkte.</p>' +
          '</div>';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var key = 'mym-announcement-' + bar.dataset.announcement;
      if (localStorage.getItem(key) === 'dismissed') {
        bar.remove();
        return;
      }
      var btn = bar.querySelector('[data-announcement-dismiss]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        try { localStorage.setItem(key, 'dismissed'); } catch (e) {}
        bar.remove();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-b2b-banner]');
    if (!bar) return;

    var code = bar.dataset.code;
    var key = 'mym-b2b-banner-' + bar.dataset.key;

    /* Auto-apply discount code — runs BEFORE dismiss check so it always fires */
    if (code) {
      var appliedKey = 'mym-b2b-discount-applied';
      if (sessionStorage.getItem(appliedKey) !== code) {
        sessionStorage.setItem(appliedKey, code);
        var returnPath = window.location.pathname + window.location.search;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(returnPath);
        return;
      }
    }

    /* Dismiss — banner only, discount stays applied */
    if (localStorage.getItem(key) === 'dismissed') {
      bar.remove();
      return;
    }

    var close = bar.querySelector('[data-b2b-dismiss]');
    if (close) {
      close.addEventListener('click', function () {
        try { localStorage.setItem(key, 'dismissed'); } catch (e) {}
        bar.remove();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-page"]) return;
  try {
    
  document.querySelectorAll('[data-brand-products]').forEach(function (root) {
    var slot = root.querySelector('[data-brand-products-grid]');
    var empty = root.querySelector('[data-brand-products-empty]');
    var seeAll = root.querySelector('[data-brand-products-all]');

    function handleOf(link) {
      return new URL(link.getAttribute('href'), window.location.origin).pathname.split('/products/')[1];
    }

    // Products already shown in a featured row above stay out of the grid.
    var shown = {};
    root.parentElement.querySelectorAll('.collection-card__link').forEach(function (link) {
      shown[handleOf(link)] = true;
    });

    var url = new URL(root.dataset.brandProducts, window.location.origin);
    url.searchParams.set('section_id', 'brand-products');
    root.setAttribute('aria-busy', 'true');

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('brand-products ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var grid = new DOMParser().parseFromString(html, 'text/html').querySelector('.brand-page__grid');
        var total = grid ? Number(grid.dataset.total) : 0;
        if (!total) {
          empty.hidden = false;
          seeAll.hidden = true;
          return;
        }
        var onPage = grid.children.length;
        grid.querySelectorAll('.collection-card__link').forEach(function (link) {
          if (shown[handleOf(link)]) link.closest('.collection-card').remove();
        });
        if (grid.children.length) slot.replaceWith(grid);
        if (total <= onPage) seeAll.hidden = true;
      })
      .catch(function (error) {
        // The see-all link stays as the way to the products.
        console.error(error);
      })
      .finally(function () {
        root.removeAttribute('aria-busy');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-campaign-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.campaign-slide');
    var indicators = root.querySelectorAll('[data-slide-target]');
    if (slides.length < 2) return;

    var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function activate(i) {
      slides[current].classList.remove('is-active');
      if (indicators[current]) indicators[current].classList.remove('is-active');
      current = ((i % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (indicators[current]) indicators[current].classList.add('is-active');
    }

    function start() {
      if (reduced) return;
      stop();
      timer = setInterval(function () { activate(current + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    indicators.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        stop();
        activate(i);
        start();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // /collections/all has no admin-editable default sort (it's a virtual route).
  // Force best-selling on first hit by redirecting once if no sort_by is set.
  (function () {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/collections/all') return;
    var params = new URLSearchParams(window.location.search);
    if (params.has('sort_by')) return;
    params.set('sort_by', 'best-selling');
    window.location.replace(window.location.pathname + '?' + params.toString());
  })();

  // Auto-submit the filter form when checkboxes, selects, or price inputs change.
  // Use form.elements so we also pick up the sort <select> that lives outside
  // the <form> element and is only associated via its `form="..."` attribute.
  document.querySelectorAll('#CollectionFilterForm').forEach(function (form) {
    Array.from(form.elements).forEach(function (el) {
      var t = (el.tagName || '').toLowerCase();
      var type = (el.type || '').toLowerCase();
      if (t === 'select' || type === 'checkbox' || type === 'number') {
        el.addEventListener('change', function () { form.submit(); });
      }
    });
  });

  // Mobile filter drawer
  (function () {
    var drawer = document.querySelector('[data-filters-drawer]');
    var backdrop = document.querySelector('[data-filters-backdrop]');
    var openBtn = document.querySelector('[data-filters-open]');
    var closeBtn = document.querySelector('[data-filters-close]');
    if (!drawer || !backdrop || !openBtn || !closeBtn) return;

    function open() {
      drawer.dataset.open = 'true';
      backdrop.dataset.open = 'true';
      backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function close() {
      drawer.dataset.open = 'false';
      backdrop.dataset.open = 'false';
      backdrop.hidden = true;
      document.body.style.overflow = '';
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') close();
    });
  })();

  // Show-more / show-less toggle on filter option lists
  document.querySelectorAll('[data-options-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-options]');
      if (!wrap) return;
      var expanded = wrap.dataset.expanded === 'true';
      var label = btn.querySelector('[data-toggle-text]');
      if (expanded) {
        delete wrap.dataset.expanded;
        if (label) label.textContent = btn.dataset.moreLabel;
      } else {
        wrap.dataset.expanded = 'true';
        if (label) label.textContent = btn.dataset.lessLabel;
      }
    });
  });

  // Inline search-in-filter for long option lists
  document.querySelectorAll('[data-option-search]').forEach(function (input) {
    var wrap = input.closest('[data-options]');
    if (!wrap) return;
    var options = wrap.querySelectorAll('.collection-filters__option');
    var toggleBtn = wrap.querySelector('[data-options-toggle]');
    input.addEventListener('input', function () {
      var q = (input.value || '').trim().toLowerCase();
      var anyHidden = false;
      options.forEach(function (opt) {
        if (q === '') {
          opt.removeAttribute('data-hidden-by-search');
        } else if ((opt.dataset.optionLabel || '').indexOf(q) === -1) {
          opt.setAttribute('data-hidden-by-search', '');
          anyHidden = true;
        } else {
          opt.removeAttribute('data-hidden-by-search');
        }
      });
      // Auto-expand the list while searching so all matches are visible
      if (q !== '') {
        wrap.dataset.expanded = 'true';
        if (toggleBtn) toggleBtn.style.display = 'none';
      } else {
        if (toggleBtn) toggleBtn.style.display = '';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchPanel = document.querySelector('[data-search-panel]');
    if (!searchToggle || !searchPanel) return;

    var input = searchPanel.querySelector('[data-search-input]');
    var form = searchPanel.querySelector('.site-search__form');
    var body = searchPanel.querySelector('[data-search-body]');
    var idle = searchPanel.querySelector('[data-search-idle]');
    var live = searchPanel.querySelector('[data-search-live]');
    var loading = searchPanel.querySelector('[data-search-loading]');
    var cardMount = searchPanel.querySelector('[data-search-card-mount]');
    var resultsEl = searchPanel.querySelector('[data-search-results]');
    var emptyEl = searchPanel.querySelector('[data-search-empty]');
    var emptyTerm = searchPanel.querySelector('[data-search-empty-term]');
    var emptyLink = searchPanel.querySelector('[data-search-empty-fullsearch]');
    var recentGroup = searchPanel.querySelector('[data-search-recent]');
    var recentList = searchPanel.querySelector('[data-search-recent-list]');

    var RECENT_KEY = 'mym.search.recent';
    var RECENT_MAX = 5;
    var MIN_QUERY = 2;
    var DEBOUNCE_MS = 160;

    // ── Recent searches ───────────────────────────────────────────
    function readRecent() {
      try { return (JSON.parse(localStorage.getItem(RECENT_KEY)) || []).filter(function (s) { return typeof s === 'string' && s.trim(); }); }
      catch (e) { return []; }
    }
    function writeRecent(list) {
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) {}
    }
    function pushRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      writeRecent(list);
    }
    function renderRecent() {
      if (!recentGroup || !recentList) return;
      var list = readRecent();
      if (list.length === 0) { recentGroup.hidden = true; return; }
      recentGroup.hidden = false;
      recentList.innerHTML = list.map(function (term) {
        var t = term.replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
        return '<li><a class="site-search__chip" href="/search?q=' + encodeURIComponent(term) + '">' + t + '</a></li>';
      }).join('');
    }

    // ── Open/close ───────────────────────────────────────────────
    function openSearch() {
      searchPanel.dataset.state = 'open';
      searchPanel.setAttribute('aria-hidden', 'false');
      searchToggle.setAttribute('aria-expanded', 'true');
      renderRecent();
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
    function closeSearch() {
      searchPanel.dataset.state = 'closed';
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    searchToggle.addEventListener('click', function () {
      if (searchPanel.dataset.state === 'open') closeSearch(); else openSearch();
    });
    searchPanel.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel.dataset.state === 'open') closeSearch();
    });

    // ── Save recent on form submit / chip click ───────────────────
    // A query resolving to exactly one product skips the results page —
    // form.submit() below does NOT re-fire this listener (a JS quirk: only
    // a real user submit / requestSubmit() does), so no infinite loop.
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input && input.value;
        pushRecent(q);
        if (!window.MymSearch || !window.MymSearch.enabled || !q) return;
        e.preventDefault();
        window.MymSearch.jumpIfSingleMatch(q).then(function (url) {
          if (url) { window.location.href = url; }
          else { form.submit(); }
        });
      });
    }

    // ── Predictive search ────────────────────────────────────────
    if (!input || !body || !idle || !live) return;

    var pending = null;
    var debounceTimer = null;
    var selectedIndex = -1;
    var requestToken = 0;

    function showIdle() {
      idle.hidden = false;
      live.hidden = true;
      selectedIndex = -1;
    }
    function showLive() {
      idle.hidden = true;
      live.hidden = false;
    }
    function setLoading(on) {
      if (loading) loading.hidden = !on;
    }
    function setResults(html) {
      resultsEl.innerHTML = html;
      emptyEl.hidden = html !== '';
      selectedIndex = -1;
    }
    function setEmpty(term) {
      resultsEl.innerHTML = '';
      emptyTerm.textContent = term;
      emptyLink.setAttribute('href', '/search?q=' + encodeURIComponent(term));
      emptyEl.hidden = false;
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function highlight(text, term) {
      var safe = escapeHtml(text);
      if (!term) return safe;
      try {
        var re = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        return safe.replace(re, '<mark>$1</mark>');
      } catch (e) { return safe; }
    }
    function fmtPrice(v) {
      if (v == null) return '';
      var kr = Math.round(parseFloat(v));
      if (isNaN(kr)) return '';
      return kr.toLocaleString('nb-NO') + ' kr';
    }
    function iconArrowRight() {
      return '<svg class="site-search__query-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
    }

    // ── Jaltest featured seeds (5 Universaldiagnose products) ─────
    var jaltestFeatured = (function () {
      var el = document.querySelector('[data-jaltest-featured]');
      if (!el) return [];
      try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
    })();
    function jaltestFeaturedForTerm(term) {
      if (!term || !jaltestFeatured.length) return [];
      var t = term.toLowerCase();
      if (t.indexOf('jal') === -1 && t.indexOf('universaldiag') === -1) return [];
      return jaltestFeatured;
    }

    function renderResults(data, term) {
      if (window.MymSearchCard) {
        if (data && data.card) { window.MymSearchCard.render(cardMount, data.card, { compact: true }); }
        else { window.MymSearchCard.hide(cardMount); }
      }
      var groups = [];
      var res = (data && data.resources && data.resources.results) || {};

      // Jaltest featured row — pinned when query matches
      var jaltestSeeds = jaltestFeaturedForTerm(term);
      if (jaltestSeeds.length) {
        var seedItems = jaltestSeeds.map(function (p) {
          var img = p.image
            ? '<img class="site-search__result-thumb" src="' + escapeHtml(p.image) + '" width="44" height="44" alt="" loading="lazy">'
            : '<span class="site-search__result-thumb site-search__result-thumb--placeholder" aria-hidden="true">·</span>';
          var vendor = p.vendor ? '<span class="site-search__result-meta">' + escapeHtml(p.vendor) + '</span>' : '';
          var priceStr = p.price ? '<span class="site-search__result-price">' + escapeHtml(p.price) + ' kr</span>' : '';
          return '<li><a class="site-search__result" href="' + escapeHtml(p.url) + '" data-search-hit>' +
                   img +
                   '<span class="site-search__result-body">' +
                     '<span class="site-search__result-title">' + highlight(p.title, term) + '</span>' +
                     vendor +
                   '</span>' +
                   priceStr +
                 '</a></li>';
        }).join('');
        groups.push(
          '<div class="site-search__results-group">' +
            '<span class="site-search__group-label">Jaltest Universaldiagnose</span>' +
            '<ul class="site-search__result-list" role="list">' + seedItems + '</ul>' +
          '</div>'
        );
      }
      // Dedupe: filter these handles from downstream products so they don't
      // appear twice.
      var seedUrls = jaltestSeeds.map(function (p) { return p.url.split('?')[0]; });
      if (seedUrls.length && res.products) {
        res = Object.assign({}, res, {
          products: res.products.filter(function (p) {
            return seedUrls.indexOf(p.url.split('?')[0]) === -1;
          })
        });
      }

      // Queries (suggested phrases) — chips at the top
      if (res.queries && res.queries.length) {
        var chips = res.queries.slice(0, 6).map(function (q) {
          return '<li><a class="site-search__query" href="/search?q=' + encodeURIComponent(q.text) +
                 '" data-search-hit>' + iconArrowRight() +
                 '<span>' + highlight(q.text, term) + '</span></a></li>';
        }).join('');
        groups.push(
          '<div class="site-search__results-group">' +
            '<span class="site-search__group-label">Forslag</span>' +
            '<ul class="site-search__chips" role="list">' + chips + '</ul>' +
          '</div>'
        );
      }

      // Products
      if (res.products && res.products.length) {
        var items = res.products.slice(0, 6).map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img class="site-search__result-thumb" src="' + escapeHtml(p.featured_image.url) + '&width=120" width="44" height="44" alt="" loading="lazy">'
            : '<span class="site-search__result-thumb site-search__result-thumb--placeholder" aria-hidden="true">·</span>';
          var vendor = p.vendor ? '<span class="site-search__result-meta">' + escapeHtml(p.vendor) + '</span>' : '';
          var priceCents = (p.price_min != null) ? p.price_min : p.price;
          var price = priceCents != null ? '<span class="site-search__result-price">' + fmtPrice(priceCents) + '</span>' : '';
          return '<li><a class="site-search__result" href="' + escapeHtml(p.url) + '" data-search-hit>' +
                   img +
                   '<span class="site-search__result-body">' +
                     '<span class="site-search__result-title">' + (p.title_html || highlight(p.title, term)) + '</span>' +
                     vendor +
                   '</span>' +
                   price +
                 '</a></li>';
        }).join('');
        groups.push(
          '<div class="site-search__results-group">' +
            '<span class="site-search__group-label">Produkter</span>' +
            '<ul class="site-search__result-list" role="list">' + items + '</ul>' +
          '</div>'
        );
      }

      // Articles + pages + collections — compact rows
      ['articles', 'pages', 'collections'].forEach(function (kind) {
        var arr = res[kind];
        if (!arr || !arr.length) return;
        var kindLabel = kind === 'articles' ? 'Kunnskapssenter' : (kind === 'pages' ? 'Sider' : 'Kategorier');
        var items = arr.slice(0, 4).map(function (r) {
          return '<li><a class="site-search__result" href="' + escapeHtml(r.url) + '" data-search-hit>' +
                   '<span class="site-search__result-body">' +
                     '<span class="site-search__result-title">' + highlight(r.title, term) + '</span>' +
                   '</span>' +
                 '</a></li>';
        }).join('');
        groups.push(
          '<div class="site-search__results-group">' +
            '<span class="site-search__group-label">' + kindLabel + '</span>' +
            '<ul class="site-search__result-list" role="list">' + items + '</ul>' +
          '</div>'
        );
      });

      if (groups.length === 0 && !(data && data.card)) {
        setEmpty(term);
      } else if (groups.length === 0) {
        // A card with no other groups is still a real result — setResults('')
        // would otherwise show the empty state itself (its own html !== ''
        // check has no way to know a card is what filled the dropdown).
        resultsEl.innerHTML = '';
        emptyEl.hidden = true;
        selectedIndex = -1;
      } else {
        setResults(groups.join(''));
      }
    }

    function fetchNative(term, controller, types, limit) {
      var url = '/search/suggest.json' +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=' + types +
        '&resources[limit]=' + limit +
        '&resources[options][unavailable_products]=last';
      return fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); });
    }

    // Products come from Meilisearch (see snippets/search-client.liquid);
    // Shopify's suggest.json is still asked for what it alone owns —
    // collections, articles, pages. Its "query" chips are dropped: they come
    // from the tokenizer Meilisearch replaces. Any Meilisearch failure falls
    // through to the full native request, so the dropdown never goes dark.
    function fetchMeili(term, controller) {
      var ms = window.MymSearch;
      var signal = controller ? controller.signal : undefined;
      return Promise.all([
        ms.search(term, { limit: 6, signal: signal }),
        fetchNative(term, controller, 'article,page,collection', 4).catch(function () { return null; })
      ]).then(function (out) {
        var native = (out[1] && out[1].resources && out[1].resources.results) || {};
        var card = out[0].card;
        // The card's own product is also in hits (same match, richer shape) —
        // drop it from the plain list so it doesn't render a second time below.
        var hits = (out[0].hits || []).filter(function (h) { return !card || h.handle !== card.handle; });
        return { resources: { results: {
          products: hits.map(function (h) {
            return {
              url: h.url,
              title: h.title,
              title_html: ms.titleHtml(h),
              vendor: h.vendor,
              featured_image: h.image_url ? { url: h.image_url } : null,
              price: h.on_request ? null : ms.priceState(h).now
            };
          }),
          articles: native.articles || [],
          pages: native.pages || [],
          collections: native.collections || []
        } }, card: card };
      });
    }

    function fetchResults(term) {
      if (pending) { try { pending.abort(); } catch (e) {} }
      var controller = ('AbortController' in window) ? new AbortController() : null;
      pending = controller;
      // Whichever request settles LAST wins the UI regardless of resolve order —
      // abort() alone isn't enough to guarantee that (a stale request can still
      // resolve, or reject as something other than AbortError, after a newer one
      // already finished), which is what left the spinner stuck under real typing.
      var myToken = ++requestToken;
      setLoading(true);
      var full = function () { return fetchNative(term, controller, 'product,article,page,collection,query', 6); };
      var request = (window.MymSearch && window.MymSearch.enabled)
        ? fetchMeili(term, controller).catch(function (err) {
            if (err && err.name === 'AbortError') throw err;
            return full();
          })
        : full();
      request
        .then(function (data) {
          if (myToken !== requestToken) return;
          setLoading(false);
          renderResults(data, term);
        })
        .catch(function (err) {
          if (myToken !== requestToken) return;
          if (err && err.name === 'AbortError') return;
          setLoading(false);
          setResults('');
          if (window.MymSearchCard) window.MymSearchCard.hide(cardMount);
        });
    }

    input.addEventListener('input', function () {
      var value = input.value.trim();
      clearTimeout(debounceTimer);
      if (value.length < MIN_QUERY) {
        setLoading(false);
        setResults('');
        if (window.MymSearchCard) window.MymSearchCard.hide(cardMount);
        showIdle();
        return;
      }
      showLive();
      setLoading(true);
      debounceTimer = setTimeout(function () { fetchResults(value); }, DEBOUNCE_MS);
    });

    // Keyboard nav across all data-search-hit elements
    function getHits() {
      return Array.from(resultsEl.querySelectorAll('[data-search-hit]'));
    }
    function updateSelection(hits) {
      hits.forEach(function (el, i) {
        if (i === selectedIndex) {
          el.setAttribute('aria-selected', 'true');
          el.scrollIntoView({ block: 'nearest' });
        } else {
          el.removeAttribute('aria-selected');
        }
      });
    }
    input.addEventListener('keydown', function (e) {
      if (live.hidden) return;
      var hits = getHits();
      if (!hits.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        selectedIndex = (selectedIndex + 1) % hits.length;
        updateSelection(hits);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        selectedIndex = selectedIndex <= 0 ? hits.length - 1 : selectedIndex - 1;
        updateSelection(hits);
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        e.preventDefault();
        pushRecent(input.value);
        var href = hits[selectedIndex].getAttribute('href');
        if (href) window.location.href = href;
      }
    });

    // Save recent on hit click
    resultsEl.addEventListener('click', function (e) {
      var hit = e.target.closest('[data-search-hit]');
      if (hit) pushRecent(input.value);
    });
  })();

  (function () {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    function open() {
      nav.dataset.state = 'open';
      nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      nav.dataset.state = 'closed';
      nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (nav.dataset.state === 'open') { close(); } else { open(); }
    });

    nav.querySelectorAll('[data-mobile-nav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    nav.querySelectorAll('a').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.dataset.state === 'open') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ss = document.querySelector('[data-slideshow]');
    if (!ss) return;
    var slides = ss.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var interval = (parseInt(ss.dataset.interval, 10) || 5) * 1000;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-content]').forEach(function (root) {
    var links = root.querySelectorAll('.product-content__nav-link[data-anchor]');
    var sections = root.querySelectorAll('.product-content__section[data-section]');
    if (!links.length || !sections.length) return;

    var byAnchor = {};
    links.forEach(function (link) { byAnchor[link.dataset.anchor] = link; });

    function setActive(id) {
      links.forEach(function (l) { l.classList.remove('is-active'); });
      var match = byAnchor[id];
      if (match) match.classList.add('is-active');
    }

    // Highlight the topmost section whose heading has scrolled past the sticky nav.
    function update() {
      var navStyles = getComputedStyle(root.querySelector('.product-content__nav'));
      var navHeight = root.querySelector('.product-content__nav').getBoundingClientRect().height;
      var headerVar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
      var threshold = window.scrollY + headerVar + navHeight + 24;
      var activeId = sections[0].dataset.section;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].offsetTop <= threshold) activeId = sections[i].dataset.section;
      }
      setActive(activeId);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.product-detail').forEach(function (root) {
    const main = root.querySelector('.product-detail__image-main img');
    const thumbs = root.querySelectorAll('.product-detail__thumb');
    if (main && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('product-detail__thumb--active'); });
          t.classList.add('product-detail__thumb--active');
          if (t.dataset.fullSrc) {
            main.src = t.dataset.fullSrc;
            if (t.dataset.fullSrcset) main.srcset = t.dataset.fullSrcset;
          }
        });
      });
    }

    const qtyWrap = root.querySelector('[data-qty]');
    if (qtyWrap) {
      const input = qtyWrap.querySelector('.qty__input');
      qtyWrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const step = parseInt(btn.dataset.qtyStep, 10) || 0;
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', function () {
        const v = parseInt(input.value, 10);
        if (!v || v < 1) input.value = 1;
      });
    }

    const stickybar = document.querySelector('[data-product-stickybar]');
    // On-request products have no add-to-cart; anchor the sticky bar to the
    // request block instead so it still reveals on scroll.
    const primaryCta = root.querySelector('.product-detail__cta') || root.querySelector('.product-detail__request');
    if (stickybar && primaryCta && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show the bar once the primary CTA scrolls out of view.
          if (entry.isIntersecting) {
            stickybar.classList.remove('is-visible');
            stickybar.setAttribute('aria-hidden', 'true');
          } else {
            stickybar.classList.add('is-visible');
            stickybar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      observer.observe(primaryCta);

      const stickyCta = stickybar.querySelector('[data-stickybar-cta]');
      if (stickyCta) {
        stickyCta.addEventListener('click', function () {
          // Scroll back to the primary form so the user picks variants/qty there.
          primaryCta.scrollIntoView({ behavior: 'smooth', block: 'center' });
          primaryCta.focus({ preventScroll: true });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var ms = window.MymSearch;

    // A query resolving to exactly one product skips the results page —
    // independent of the island below (which needs an already-performed
    // search to exist at all), so this runs even on a blank /search visit
    // where the visitor is about to type their first query.
    var form = document.querySelector('.search-page__form');
    var formInput = form && form.querySelector('input[name="q"]');
    if (form && formInput && ms && ms.enabled) {
      form.addEventListener('submit', function (e) {
        var q = formInput.value;
        if (!q) return;
        e.preventDefault();
        ms.jumpIfSingleMatch(q).then(function (url) {
          if (url) { window.location.href = url; }
          else { form.submit(); }
        });
      });
    }

    var island = document.querySelector('[data-search-island]');
    if (!island || !ms || !ms.enabled) return;
    var type = island.dataset.type;
    if (type !== 'all' && type !== 'product') return;
    var terms = island.dataset.terms;
    if (!terms) return;

    var PER_PAGE = 24;
    var esc = ms.esc;
    var S = ms.strings;
    var cardMount = island.querySelector('[data-search-card-mount]');
    var results = island.querySelector('[data-search-island-results]');
    var grid = island.querySelector('[data-search-grid]');
    var pagination = island.querySelector('[data-search-pagination]');
    var emptyEl = island.querySelector('[data-search-island-empty]');
    var inquiryEl = island.querySelector('[data-search-island-inquiry]');
    var natives = Array.prototype.slice.call(document.querySelectorAll('[data-search-native]'));
    var badge = document.querySelector('.search-page__count-badge');
    var badgeLabel = badge ? badge.nextElementSibling : null;
    var cartAddUrl = island.dataset.cartAddUrl || '/cart/add';
    var icons = {};
    Array.prototype.forEach.call(island.querySelectorAll('template[data-search-icon]'), function (t) {
      icons[t.getAttribute('data-search-icon')] = t.innerHTML.trim();
    });
    var skip = [];
    var featured = document.querySelector('[data-featured-handles]');
    if (featured) { try { skip = JSON.parse(featured.getAttribute('data-featured-handles')) || []; } catch (e) {} }
    var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;

    // Server-rendered after the island (see the Jaltest search-trigger
    // comment above) so it has paginate.current_page in scope — moved here
    // in front of the island so it still displays above the results grid.
    if (featured && featured.parentNode) { featured.parentNode.insertBefore(featured, island); }

    natives.forEach(function (el) { el.hidden = true; });
    island.hidden = false;
    grid.innerHTML = skeleton(8);

    ms.search(terms, { hitsPerPage: PER_PAGE, page: page })
      .then(render)
      .catch(function () {
        island.hidden = true;
        natives.forEach(function (el) { el.hidden = false; });
      });

    function skeleton(n) {
      var card = '<li class="collection-card collection-card--skeleton" aria-hidden="true">' +
        '<div class="collection-card__link"><div class="collection-card__media"></div>' +
        '<div class="collection-card__title"></div><div class="collection-card__price"></div></div></li>';
      var out = '';
      for (var i = 0; i < n; i++) out += card;
      return out;
    }

    // Mirrors snippets/product-card.liquid class for class so its CSS applies.
    function card(h) {
      var onRequest = !!h.on_request || !(h.price > 0);
      var ps = ms.priceState(h);
      var onSale = !onRequest && !!ps.was;
      var discount = onSale ? ps.percent : 0;
      var url = esc(h.url);
      var title = esc(h.title);
      var media = h.image_url
        ? '<img class="collection-card__image" src="' + esc(ms.imageUrl(h.image_url, 600)) + '"' +
          ' srcset="' + [300, 450, 600, 900].map(function (w) { return esc(ms.imageUrl(h.image_url, w)) + ' ' + w + 'w'; }).join(', ') + '"' +
          ' sizes="(min-width: 1024px) 25vw, (min-width: 640px) 33vw, 50vw" loading="lazy" alt="' + title + '">'
        : '<span class="collection-card__placeholder">Ingen bilde</span>';
      if (onSale) media += '<span class="collection-card__badge">\u2212' + discount + '%</span>';

      var price;
      if (onRequest) {
        price = '<span class="collection-card__price-request">' + esc(S.priceOnRequest) + '</span>';
      } else if (onSale) {
        price = '<span class="collection-card__price-current">' + esc(ms.money(ps.now)) + '</span>' +
          '<span class="collection-card__price-compare">' + esc(ms.money(ps.was)) + '</span>' +
          '<span class="collection-card__price-tax">' + esc(S.priceNote) + '</span>';
      } else {
        price = esc(ms.money(ps.now)) + ' <span class="collection-card__price-tax">' + esc(S.priceNote) + '</span>';
      }

      var action = '';
      if (onRequest) {
        action = '<a href="' + url + '" class="collection-card__qa-btn collection-card__qa-btn--ghost" aria-label="' + esc(S.priceOnRequest) + ' \u2014 ' + title + '">' + icons['arrow-right'] + '</a>';
      } else if (h.available) {
        if (h.variants_count > 1 || !h.variant_id) {
          action = '<a href="' + url + '" class="collection-card__qa-btn collection-card__qa-btn--ghost" aria-label="Velg variant for ' + title + '">' + icons['arrow-right'] + '</a>';
        } else {
          action = '<form action="' + esc(cartAddUrl) + '" method="post" class="collection-card__qa-form">' +
            '<input type="hidden" name="id" value="' + h.variant_id + '"><input type="hidden" name="quantity" value="1">' +
            '<button type="submit" class="collection-card__qa-btn collection-card__qa-btn--primary" aria-label="Legg ' + title + ' i kurv">' + icons['plus'] + '</button></form>';
        }
      }

      return '<li class="collection-card">' +
        '<a href="' + url + '" class="collection-card__link">' +
          '<div class="collection-card__media">' + media + '</div>' +
          (h.vendor ? '<span class="collection-card__brand">' + esc(h.vendor) + '</span>' : '') +
          '<h3 class="collection-card__title">' + title + '</h3>' +
          '<p class="collection-card__price">' + price + '</p>' +
        '</a>' + action +
      '</li>';
    }

    function pageHref(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', n);
      return u.pathname + u.search;
    }

    function renderPagination(current, totalPages) {
      if (totalPages <= 1) { pagination.hidden = true; return; }
      var parts = [];
      parts.push(current > 1
        ? '<a class="prev" href="' + esc(pageHref(current - 1)) + '" aria-label="Forrige side">\u2039</a>'
        : '<span class="prev deactivated" aria-hidden="true">\u2039</span>');
      var last = 0;
      for (var n = 1; n <= totalPages; n++) {
        if (n !== 1 && n !== totalPages && Math.abs(n - current) > 2) continue;
        if (n - last > 1) parts.push('<span class="deco">\u2026</span>');
        parts.push(n === current
          ? '<span class="page current" aria-current="page">' + n + '</span>'
          : '<a class="page" href="' + esc(pageHref(n)) + '">' + n + '</a>');
        last = n;
      }
      parts.push(current < totalPages
        ? '<a class="next" href="' + esc(pageHref(current + 1)) + '" aria-label="Neste side">\u203a</a>'
        : '<span class="next deactivated" aria-hidden="true">\u203a</span>');
      pagination.innerHTML = '<div>' + parts.join('') + '</div>';
      pagination.hidden = false;
    }

    function render(data) {
      if (window.MymSearchCard) {
        if (data.card) { window.MymSearchCard.render(cardMount, data.card); }
        else { window.MymSearchCard.hide(cardMount); }
      }
      // The card's own product is also in hits (same match, richer shape) —
      // drop it from the grid so it doesn't render a second time underneath.
      var cardHandle = data.card && data.card.handle;
      var hits = (data.hits || []).filter(function (h) {
        return skip.indexOf(h.handle) === -1 && h.handle !== cardHandle;
      });
      var total = data.totalHits != null ? data.totalHits : hits.length;
      if (badge) {
        badge.textContent = total;
        if (badgeLabel) badgeLabel.textContent = total === 1 ? island.dataset.singular : island.dataset.plural;
      }
      if (!hits.length && !data.card) {
        results.hidden = true;
        pagination.hidden = true;
        emptyEl.hidden = false;
        return;
      }
      // A card with no other hits (e.g. a plate query with one match, or an
      // exact part number nothing else shares) still counts as a real result —
      // just the grid section under it stays empty rather than showing "0 treff".
      results.hidden = !hits.length;
      grid.innerHTML = hits.map(card).join('');
      inquiryEl.hidden = false;
      renderPagination(data.page || 1, data.totalPages || 1);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thegenius-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-tg-conf]');
    var dataEl = document.querySelector('[data-tg-data]');
    if (!root || !dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cats = data.categories || [];
    var labels = data.labels || {};

    var state = { category: null, tier: null };

    var stages = root.querySelectorAll('[data-tg-stage]');
    var stepBtns = root.querySelectorAll('[data-tg-step-btn]');
    var panels = root.querySelectorAll('[data-tg-panel]');
    var backdrop = root.querySelector('[data-tg-backdrop]');
    var railCategory = root.querySelector('[data-tg-rail-category]');
    var railTier = root.querySelector('[data-tg-rail-tier]');
    var railTotal = root.querySelector('[data-tg-rail-total]');
    var railStock = root.querySelector('[data-tg-rail-stock]');
    var upsellBtn = root.querySelector('[data-tg-upsell]');
    var upsellDelta = root.querySelector('[data-tg-upsell-delta]');
    var variantInput = root.querySelector('[data-tg-variant-input]');
    var cta = root.querySelector('[data-tg-cta]');
    var configField = root.querySelector('[data-tg-config-field]');
    var mbarLabel = root.querySelector('[data-tg-mbar-label]');
    var mbarTotal = root.querySelector('[data-tg-mbar-total]');
    var mbarCta = root.querySelector('[data-tg-mbar-cta]');

    var expansionIdx = -1;
    cats.forEach(function (c, i) { if (c.expansion) expansionIdx = i; });

    function fmtDelta(cents) {
      return '+ ' + (cents / 100).toLocaleString('nb-NO', { maximumFractionDigits: 0 }) + ' kr';
    }

    function defaultTier(cat) {
      if (cat.tiers.combo) return 'combo';
      var keys = Object.keys(cat.tiers);
      return keys.length ? keys[0] : null;
    }

    function showStage(n) {
      stages.forEach(function (s) { s.hidden = s.getAttribute('data-tg-stage') !== String(n); });
      stepBtns.forEach(function (b) {
        var num = Number(b.getAttribute('data-tg-step-btn'));
        b.classList.toggle('is-active', num === n);
        b.classList.toggle('is-done', num < n);
        b.disabled = num === 2 && state.category === null;
      });
    }

    function update() {
      if (state.category === null) return;
      var cat = cats[state.category];
      var tier = state.tier && cat.tiers[state.tier] ? cat.tiers[state.tier] : null;

      panels.forEach(function (p) {
        var idx = Number(p.getAttribute('data-tg-panel'));
        p.hidden = idx !== state.category;
        if (idx === state.category) {
          p.querySelectorAll('[data-tg-tier]').forEach(function (t) {
            t.setAttribute('aria-pressed', String(t.getAttribute('data-tg-tier') === state.tier));
          });
        }
      });

      if (backdrop) {
        if (cat.image) { backdrop.src = cat.image; backdrop.parentElement.style.display = ''; }
        else { backdrop.parentElement.style.display = 'none'; }
      }

      railCategory.textContent = cat.title;
      railTier.textContent = tier ? tier.label : '';
      railTotal.textContent = tier ? tier.formatted : '';

      if (tier) {
        if (tier.qty > 0) {
          railStock.textContent = labels.railStockIn || 'På lager, klar til sending';
        } else if (tier.available) {
          railStock.textContent = labels.railStockOrder || 'Bestillingsvare';
        } else {
          railStock.textContent = labels.outOfStock || 'Ikke tilgjengelig';
        }
        variantInput.value = tier.variantId;
        cta.disabled = !tier.available;
      } else {
        railStock.textContent = '';
        variantInput.value = '';
        cta.disabled = true;
      }

      if (mbarLabel) mbarLabel.textContent = cat.title + (tier ? ' · ' + tier.label : '');
      if (mbarTotal) mbarTotal.textContent = tier ? tier.formatted : '';
      if (mbarCta) mbarCta.disabled = !tier || !tier.available;

      /* Expansion upsell: honest delta to the all-categories block at the same tier */
      var showUpsell = false;
      if (upsellBtn && expansionIdx >= 0 && state.category !== expansionIdx && tier) {
        var expTier = cats[expansionIdx].tiers[state.tier];
        if (expTier && expTier.available && expTier.cents > tier.cents) {
          upsellDelta.textContent = fmtDelta(expTier.cents - tier.cents);
          showUpsell = true;
        }
      }
      if (upsellBtn) upsellBtn.hidden = !showUpsell;

      if (configField) {
        configField.value = cat.title + (tier ? ' / ' + tier.label : '');
      }
    }

    root.querySelectorAll('[data-tg-vehicle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = Number(btn.getAttribute('data-tg-vehicle'));
        state.tier = defaultTier(cats[state.category]);
        showStage(2);
        update();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-tg-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.tier = btn.getAttribute('data-tg-tier');
        update();
      });
    });

    if (upsellBtn) {
      upsellBtn.addEventListener('click', function () {
        if (expansionIdx < 0) return;
        state.category = expansionIdx;
        if (!cats[expansionIdx].tiers[state.tier]) state.tier = defaultTier(cats[expansionIdx]);
        update();
      });
    }

    stepBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var num = Number(b.getAttribute('data-tg-step-btn'));
        if (num === 1) showStage(1);
        else if (state.category !== null) { showStage(2); update(); }
      });
    });

    showStage(1);
  })();

  } catch(e) { console.error(e); }
})();
})();
